import { ProductListingPage } from "@decocms/apps-commerce/types";
import Button from "~/components/ui/Button";
import type { LegacySort } from "@decocms/apps-vtex/utils/types";
import {
  useSort,
  applySort,
  applySortMobile,
  portugueseMappings,
} from "../../utils/sort";

export type Props = Pick<ProductListingPage, "sortOptions"> & {
  currentSort?: LegacySort;
};

function DesktopSort({ sortOptions }: Props) {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return null;
  }

  const sort = useSort();

  return (
    <select
      id="sort"
      name="sort"
      onChange={applySort}
      className="font-['Poppins'] text-[13px] text-[#333333] font-normal w-50 h-[34px] py-0 rounded cursor-pointer"
    >
      {sortOptions
        .map(({ value, label }) => ({
          value,
          label: portugueseMappings[label as keyof typeof portugueseMappings] ??
            label,
        }))
        .filter(({ label }) => label)
        .map(({ value, label }) => (
          <option key={value} value={value} selected={value === sort}>
            <span className="text-sm">{label}</span>
          </option>
        ))}
    </select>
  );
}

function MobileSort({ sortOptions }: Props) {
  return (
    <ul className="w-full pt-[5px]">
      {sortOptions
        .map(({ value, label }) => ({
          value,
          label: portugueseMappings[label as keyof typeof portugueseMappings] ??
            label,
        }))
        .filter(({ label }) => label)
        .map(({ value, label }) => (
          <li className="flex justify-center" key={value}>
            <Button
              className="font-['Poppins'] text-sm text-black py-2.5 uppercase"
              onClick={() => applySortMobile(value)}
              aria-label="Ordernar"
            >
              {label}
            </Button>
          </li>
        ))}
    </ul>
  );
}

export { DesktopSort, MobileSort };
